import React from 'react';
import './App.css';
import Router from './Router';
import { LanguageProvider } from './context/LanguageContext/LanguageContext';
import ComingSoon from './components/ComingSoon/ComingSoon';
import { ParallaxProvider } from 'react-scroll-parallax';

function App() {
    return (
        <LanguageProvider>
            <ParallaxProvider>
                {/* <ComingSoon /> */}
                <Router />
            </ParallaxProvider>
        </LanguageProvider>
    );
}
export default App;
